<template>
    <div id="wrapper">
        <side-bar :memuData="view.memuData" :memuConfig="view.memuConfig" :dashboardConfig="view.dashboardConfig"></side-bar>
        <div class="d-flex flex-column" id="content-wrapper">
            <div class="content" id="content">
                <top-bar></top-bar>
                <router-view></router-view>
            </div>
        </div>
    </div>
</template>

<script>
import SideBar from '@/components/layouts/SideBar'
import TopBar from '@/components/layouts/TopBar'
import { getLocalUserInfo, setPermission } from "@/models/HELPERS/common.js";
import { sideMemuData } from "@/models/HELPERS/options.js";

export default {
    name: 'yfLayout',
    components:{
        SideBar,
        TopBar
    },
    data() {
        return {
            view: {
                memuConfig: {
                    link: '/backstage/yf/contract',
                    systemName: '永豐網路平台',
                    version: '1.0'
                },
                dashboardConfig: {
                  title: '儀表板',
                  link: '/backstage/yf/dashboard',
                  display: true
                },
                memuData: []
            },
        }
    },
    mounted() {
        this.load();
    },
    methods: {
      async load() {
          //側邊欄重整子選單不能關閉
          // let subMenu = JSON.parse(localStorage.getItem('sideBar')) || null;
          // if(subMenu) this.view.memuData = subMenu;

          this.memuDataHandler();
      },
      // sidebar 資料處理
      memuDataHandler() {
        const meta = this.$route.meta;
        const info = getLocalUserInfo(meta.authority);

        this.view.memuData = sideMemuData;
        setPermission(this.view.memuData, info.permission);
      }
    }
}
</script>

<style lang="scss" scoped>
// Main page wrapper
// #wrapper {
//   display: flex;
//   height: 100vh;
//   #content-wrapper {
//     background-color: #FFFFFF;
//     width: 100vw;
//     height: 100%;
//     overflow-x: hidden;
//     #content {
//       flex: 1 0 auto;
//       height: 100%;
//       @media screen and (max-width: 720px) {
//         margin-left: 0vw !important;
//       }
//     }
//   }
// }
#wrapper {
  display: flex;
  #content-wrapper {
    background-color: #FFFFFF;
    flex: 1 1 auto;
    overflow: hidden;
    // width: 100vw;
    #content {
      flex: 1 0 auto;
      min-height: 100vh;
      @media screen and (max-width: 720px) {
        margin-left: 0vw !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/Layout.vue